import React, { Component } from 'react';
import './FlowerPlaceholder.css';

const PETAL_COUNT = 9
const FLOWER_COUNT = 4
export default class FlowerPlaceHolder extends Component {
  leaves() {
    return [...Array(PETAL_COUNT).keys()].map(leafIndex => {
      return <div className={`leaf_${leafIndex}`} key={leafIndex}></div>
    })
  }

  flowers() {
    return [...Array(FLOWER_COUNT).keys()].map(flowerIndex => {
      return <div className={`layers_${flowerIndex}`} key={flowerIndex}>{ this.leaves() }</div>
    })
  }

  render() {
    return (
      <div className="flower-container">
        <div className="center"></div>
        {this.flowers()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FlowerPlaceholder.js